import React from "react";
import { motion } from "framer-motion";

export function Logo({ size = 34, showText = true }) {
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="app-logo">
      <div className="relative" style={{ width: size, height: size }}>
        <motion.div
          className="absolute inset-0 rounded-xl"
          style={{ background: "linear-gradient(135deg,#4F46E5,#00E5FF)" }}
          animate={{ boxShadow: ["0 0 12px rgba(99,102,241,0.5)", "0 0 22px rgba(0,229,255,0.6)", "0 0 12px rgba(99,102,241,0.5)"] }}
          transition={{ duration: 3, repeat: Infinity }}
        />
        <div className="absolute inset-0 flex items-center justify-center font-display font-black text-white" style={{ fontSize: size * 0.5 }}>L</div>
      </div>
      {showText && (
        <span className="font-display font-extrabold tracking-tight text-[0.85rem] sm:text-[1.05rem] leading-none whitespace-nowrap">
          LOCALBOOST <span className="neon-text">AI</span>
        </span>
      )}
    </div>
  );
}
